import { GetRegionDirectoryList,CreateRegion,UpdateRegion,UpdateStatusRegion,GetRegionDirectoryListDropDown } from '@/actions/directoryActions.js'
import { normalizeDirectoryText, showDirectoryPageWithRecord } from '@/helpers/directoryPagination.js'

const findDirectoryRecord = (list, matches) => Array.isArray(list?.docs)
    ? list.docs.find(matches)
    : null

const state ={
    regionList :{
        docs: [],
        totalPages : 0,
    },
    regionData:{},
    regionDataUpdate : {},
    regionDropDownList : [],
    search : '',
    page : 1,
    highlightedRegionId : ''
}
const getters = {
    regionList : state => state.regionList,
    regionDataUpdate : state => state.regionDataUpdate,
    regionSearch : state => state.search,
    regionPage : state => state.page,
    regionDropDownList : state => state.regionDropDownList,
    highlightedRegionId : state => state.highlightedRegionId
}
const actions = {
    async GetRegionList({commit},data = {search : '',  page : 1 }){
        let search = data.search || ''
        let page = data.page || 1

        commit('setRegionPage',page)
        commit('setRegionSearch',search)

        const getData = await GetRegionDirectoryList(search, page).catch()
  
        if(getData){
            commit('setRegionList',getData)
        }

        return getData
    },
    async GetRegionListDropdown({commit}){
        const data = await GetRegionDirectoryListDropDown().catch()
        if(data){
            commit('setRegionDropDownList', data)
        }
    },
    async CreateRegionRun ({dispatch, commit},data){
        const create = await CreateRegion(data).catch()
        if(create=="OK"){
            const createdRegionName = normalizeDirectoryText(data.regionName)
            const matches = (region) => normalizeDirectoryText(region.regionName) === createdRegionName
            const firstPage = await dispatch('GetRegionList', {search : '', page : 1})
            const pageData = await showDirectoryPageWithRecord({
                firstPage,
                loadPage: (page) => dispatch('GetRegionList', {search : '', page}),
                matches
            })
            const matchedRegion = findDirectoryRecord(pageData, matches)
            commit('setHighlightedRegionId', matchedRegion?._id || '')
        }

        return create
    },
    async UpdateRegionRun ({dispatch, commit},data){
        const {regionSearch} = this.getters
        const update = await UpdateRegion(data).catch()
        if(update=="OK"){
            const updatedRegionName = normalizeDirectoryText(data.regionName)
            const matches = (region) => {
                return (data._id && region._id === data._id) ||
                    normalizeDirectoryText(region.regionName) === updatedRegionName
            }
            const loadMatchingPage = async (search) => {
                const firstPage = await dispatch('GetRegionList', {page : 1, search})
                const pageData = await showDirectoryPageWithRecord({
                    firstPage,
                    loadPage: (page) => dispatch('GetRegionList', {search, page}),
                    matches
                })
                const matchedRegion = findDirectoryRecord(pageData, matches)
                if(matchedRegion){
                    commit('setHighlightedRegionId', matchedRegion._id)
                    return true
                }

                return false
            }

            commit('setHighlightedRegionId', '')
            if(!(await loadMatchingPage(regionSearch || '')) && regionSearch){
                await loadMatchingPage('')
            }
        }

        return update
    },
    async UpdateRegionStatusRun (obj,data){
        const update = await UpdateStatusRegion(data).catch()
        if(update=="OK"){
            const regionList= this.getters.regionList.docs
            const index = regionList.findIndex((u)=>u._id===data)
            regionList[index].status = !regionList[index].status
        }

        return update
    },
    SetRegionUpdate({commit},data){
        commit('setRegionDataUpdate',data)
    },
    ClearRegionHighlight({commit}){
        commit('setHighlightedRegionId','')
    }
}
const mutations = {
    setRegionList : (state, data) => (state.regionList = data),
    setRegionDataUpdate : (state, data) => (state.regionDataUpdate = data),
    setRegionPage : (state, data) => (state.page = data),
    setRegionSearch : (state, data) => (state.search = data),
    setRegionDropDownList : (state,data) => (state.regionDropDownList = data),
    setHighlightedRegionId : (state, data) => (state.highlightedRegionId = data)
}


export default {
    state,
    getters,
    actions,
    mutations
}
